let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("igmsI")).then(() => parcelRequire('i4pBY'));